// TextViewer.js
import React from 'react';
import './textViewer.css'; // Create a CSS file for TextViewer styles

const TextViewer = ({ isOpen, onClose, content, title }) => {
    if (!isOpen) return null;

    return (
        <div className="textViewer-overlay">
            <div className="textViewer-content">
                <button className="textViewer-close" onClick={onClose}>X</button>
                <h2>{title}</h2>
                <div className="textViewer-body">
                    <p>{content}</p>
                </div>
            </div>
        </div>
    );
};

export default TextViewer;
